__webpack_require__.p = "https://tastermpoint-mfe-support-stage.maersk.io/mfe/support/";